import React from 'react';

import { iconBaseProps, type IconProps } from './IconBase';

const HouseIcon: React.FC<IconProps> = props => (
  <svg {...iconBaseProps} {...props}>
    <path d="M4 11.5 12 4l8 7.5" />
    <path d="M6 10v9a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1v-9" />
    <path d="M10 20v-5h4v5" />
  </svg>
);

export default HouseIcon;
